export enum OnboardingFailureCode {
  NoToken = 'no_token',
  InvalidToken = 'invalid_token',
  ExpiredToken = 'expired_token',
  Unknown = 'unknown',
  MissingDataProperties = 'missing_data_properties',
}
